import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ContactPage from "./pages/contact-us";
import AboutPage from "./pages/about-us";
import ProductPage from "./pages/products";
import HardwarePage from "./pages/hardware";
import SoftwarePage from "./pages/software";
import PrivacyPolicy from "./pages/privacy-policy";
import NotFound from "./pages/NotFound";
import MainLayout from "./layouts/MainLayout";
import KDSPage from "./pages/kds";
import CDSPage from "./pages/cds";
import Registration from "./components/Registration";
import GrabFoodPage from "./pages/grabfood";
import QROrderPage from "./pages/qr-order";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <App />,
      },
      {
        path: "contact-us",
        element: <ContactPage />,
      },
      {
        path: "about-us",
        element: <AboutPage />,
      },
      {
        path: "products",
        element: <ProductPage />,
      },
      {
        path: "software",
        element: <SoftwarePage />,
      },
      {
        path: "hardware",
        element: <HardwarePage />,
      },
      {
        path: "kds",
        element: <KDSPage />,
      },
      {
        path: "cds",
        element: <CDSPage />,
      },
      {
        path: "pricing",
        element: <Registration />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "grabfood",
        element: <GrabFoodPage />,
      },
      {
        path: "qr-order",
        element: <QROrderPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
